<template>
  <div class="two-column-table">
    <div class="two-column-table__row" v-for="row in data" :key="row.key">
      <div class="two-column-table__cell">
        {{ row.key }}
      </div>
      <div class="two-column-table__cell">
        {{ row.value }}
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    /**
     * @typedef {Object} TableItem
     * @property {string} key
     * @property {string} value
     */
    data: {
      /**
       * @type {import('vue').PropType<Array<TableItem>>}
       */
      type: Array,
      required: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.two-column-table {
  &__row {
    display: flex;
  }

  &__cell {
    padding: 7px 5px;
    width: 70%;
    font-size: 12px;
    line-height: 15px;
    text-align: left;

    &:first-child {
      color: #a8a8a8;
      width: 30%;
      text-align: right;
      margin-right: 11px;
    }
  }
}
</style>
